import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { Stack } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
import { ExportIcon } from '../../../../icons';
import { useSubscriptionPaymentContext } from '../hooks';
import S from '../SubscriptionPayment.module.scss';
export const PlanCheckoutSpace = () => {
  const {
    space
  } = useSubscriptionPaymentContext();
  return <div className={S.section_container} data-sentry-component="PlanCheckoutSpace" data-sentry-source-file="PlanCheckoutSpace.tsx">
      <PlanAppliedMessage data-sentry-element="PlanAppliedMessage" data-sentry-source-file="PlanCheckoutSpace.tsx" />
      <SpaceSubscriptionInfo thumbnailUrl={space.thumbnailUrl} spaceName={space.name} entryMapHashId={space.entryMapHashId} data-sentry-element="SpaceSubscriptionInfo" data-sentry-source-file="PlanCheckoutSpace.tsx" />
    </div>;
};
export const SpaceSubscriptionInfo = (props: {
  thumbnailUrl: string;
  spaceName: string;
  entryMapHashId: string;
}) => {
  return <Stack direction={'row'} gap={12} style={{
    alignItems: 'center'
  }} data-sentry-element="Stack" data-sentry-component="SpaceSubscriptionInfo" data-sentry-source-file="PlanCheckoutSpace.tsx">
      <div className={S.section_thumbnail}>
        <img src={props.thumbnailUrl} alt="thumbnail" />
      </div>
      <Stack gap={10} data-sentry-element="Stack" data-sentry-source-file="PlanCheckoutSpace.tsx">
        <Stack gap={4} direction={'column'} data-sentry-element="Stack" data-sentry-source-file="PlanCheckoutSpace.tsx">
          <div className={S.section_space_name}>{props.spaceName}</div>
          <div className={S.section_space_link}>
            <ExportIcon width={16} height={16} fill={Colors.Gray600} data-sentry-element="ExportIcon" data-sentry-source-file="PlanCheckoutSpace.tsx" />
            <Link target="_blank" href={`${process.env.NEXT_PUBLIC_BASE_URL}/play/${props.entryMapHashId}`} prefetch={false} data-sentry-element="Link" data-sentry-source-file="PlanCheckoutSpace.tsx">
              {(process.env.NEXT_PUBLIC_BASE_URL || '').split('https://')[1]}
              /play/{props.entryMapHashId}
            </Link>
          </div>
        </Stack>
      </Stack>
    </Stack>;
};
//
export const PlanAppliedMessage = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <Stack gap={4} data-sentry-element="Stack" data-sentry-component="PlanAppliedMessage" data-sentry-source-file="PlanCheckoutSpace.tsx">
      <div className={S.section_title}>
        {t('subscription:payment.planSelect.subtitleSpaceSelect')}
      </div>
      <div className={S.section_sub_title}>
        {t('subscription:payment.planSelect.descriptionSpaceSelect')}
      </div>
    </Stack>;
};